var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSegmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5,
    fill: "#8B5CF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3842 7.25508C14.7243 6.91497 15.2757 6.91497 15.6158 7.25508L22.7449 14.3842C23.085 14.7243 23.085 15.2757 22.7449 15.6158L15.6158 22.7449C15.2757 23.085 14.7243 23.085 14.3842 22.7449L7.25508 15.6158C6.91497 15.2757 6.91497 14.7243 7.25508 14.3842L14.3842 7.25508Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegmentIcon);
export default __webpack_public_path__ + "static/media/SegmentIcon.4bfca8c647894c3167896cf3388439c0.svg";
export { ForwardRef as ReactComponent };